import { KeyboardEvent, LegacyRef, useEffect, useRef, useState } from "react"

export const useMenu = (visible: boolean) => {
  const menuParentRef: LegacyRef<HTMLDivElement> = useRef(null)

  const [focusIndex, setFocusIndex] = useState(0)
  const menuItemsRef = useRef<HTMLDivElement[]>([])

  useEffect(() => {
    if (!menuParentRef.current) return

    const allMenuItems = Array.from(
      menuParentRef.current.querySelectorAll("[role=menuitem]")
    ) as HTMLDivElement[]
    menuItemsRef.current = allMenuItems
  }, [])

  useEffect(() => {
    if (visible) {
      setFocusIndex(0)
      const firstElement = menuItemsRef.current[0]
      firstElement?.focus()
    }
  }, [visible])

  const keyboardHandler = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      return
    }

    const menuItems = menuItemsRef.current
    const menuItemSize = menuItems.length
    const KEY_MAPPER: Record<string, number> = {
      ArrowDown: focusIndex + 1,
      ArrowUp: focusIndex - 1
    }

    let newFocusIndex = KEY_MAPPER[e.key] || 0
    newFocusIndex =
      newFocusIndex < 0 ? menuItemSize + newFocusIndex : newFocusIndex

    if (newFocusIndex !== focusIndex) {
      menuItems[newFocusIndex % menuItemSize].focus()
      setFocusIndex(newFocusIndex)
    }
  }

  return { keyboardHandler, menuParentRef, visible }
}
